import { apiClient } from '@/services/_shared/apiClient';
import ENDPOINTS from '@/utils/endpoints';
import type {
  SubscriptionPlan,
  CurrentSubscription,
  SubscriptionHistoryItem,
} from '../modules/subscriptions/pages/types';

interface ApiResponse<T> {
  status: string;
  message: string;
  data: T;
}

interface PaginatedHistoryResponse {
  current_page: number;
  data: SubscriptionHistoryItem[];
  per_page: number;
  total: number;
  last_page: number;
}

export async function fetchSubscriptionPlans(): Promise<SubscriptionPlan[]> {
  const response = await apiClient.get<ApiResponse<SubscriptionPlan[]>>(
    ENDPOINTS.SUBSCRIPTION_PLANS
  );
  return response.data.data;
}

export async function fetchCurrentSubscription(): Promise<CurrentSubscription | null> {
  const response = await apiClient.get<ApiResponse<CurrentSubscription | null>>(
    ENDPOINTS.SUBSCRIPTION_CURRENT
  );
  return response.data.data;
}

export async function fetchSubscriptionHistory(perPage = 10): Promise<PaginatedHistoryResponse> {
  const response = await apiClient.get<ApiResponse<PaginatedHistoryResponse>>(
    ENDPOINTS.SUBSCRIPTION_HISTORY,
    { params: { per_page: perPage } }
  );
  return response.data.data;
}

export async function purchaseWithWallet(
  planId: string
): Promise<{ success: boolean; message: string }> {
  const response = await apiClient.post(ENDPOINTS.SUBSCRIPTION_PURCHASE_WALLET, {
    plan_id: planId,
  });
  return {
    success: response.data.status === 'success',
    message: response.data.message,
  };
}
